<div class="idp-radio-section__header">
  <idp-radio-button
    class="header__radio"
    (clicked)="onSelected($event)"
    (radioFocus)="onFocus($any($event))"
    [ariaLabel]="content.ariaLabel"
    [id]="'idp-' + content.id! + '__selected'"
    [checked]="checked!"
  ></idp-radio-button>
  <div [innerHTML]="content.title" class="header__title"></div>
</div>
<div
  *ngIf="content.subtitle"
  [innerHTML]="subtitle"
  class="idp-radio-section__subtitle"
></div>
<div class="idp-radio-section__content">
  <ng-content></ng-content>
</div>
